import { createStore } from "vuex";

export default createStore({
  state: {
    hash:null,
    full_name:null,
    employee_key:null,
    emp_info:null,
    divisionList:[],
    religion:[
      {
         key : 1,
         name : 'ROMAN CATHOLIC'
      },
      {
        key : 1,
        name : 'ISLAM'
      },
      {
        key : 1,
        name : 'IGLESIA NI CRISTO'
      },
      {
        key : 1,
        name : 'PHILIPPINE INDEPENDENT CHURCH'
      },
      {
        key : 1,
        name : 'SEVETH-DAY ADVENTIST'
      },
    
    ],
  }
});

